<template>
  <GenericReport
    ref="report"
    class="maxh-1bar clean-list"
    hide-header
    orientation="horizontal"
    :reportSpec="reportSpec"
    :adapterSpec="adapterSpec"
    :fetcher="fetchData"
    :limits="[5, 10, 50, 100, 300]"
    selectable
    @update:selected="(x) => (selectedIds = x)"
    @rowClicked="showRowDetails"
    rememberLastClick
  >
    <template v-slot:topbar-actions>
      <OSimpleDialog
        ref="deleteDialog"
        :maxWidth="600"
        @apply="doDelete"
        title="Remover Ocorrências"
      >
        <v-card-text class="pa-3">
          <div class="w-full pa-3">
            Deseja realmente remover as {{ selectedIds.length }}
            ocorrências selecionadas? Esta operação irá gerar um histórico.
          </div>
          <v-form ref="deleteForm" v-model="deleteIsValid" class="w-full">
            <OTextField
              class="pa-3"
              filled
              v-model="deleteComments"
              :rules="[isSet]"
              label="Comentários"
              placeholder="Descreva a razão para remover estas ocorrências."
            />
          </v-form>
        </v-card-text>
      </OSimpleDialog>

      <OMenuButton :menuOpts="menuOpts" />
    </template>
  </GenericReport>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { OrgApi } from '@/models'
import utils from 'oderon-commons/src/utils.js'
import { fullSpec } from '../../vehicle/occur-columns.js'
import TheUser from 'oderon-vue/auth/TheUser'
import OSimpleDialog from 'oderon-vue/cpts/dialogs/OSimpleDialog.vue'
import { isSet } from 'oderon-vue/utils.js'

export default {
  expose: ['reload'],
  tabTitle: 'Ocorrências',
  components: {
    GenericReport,
    OSimpleDialog
  },
  props: {
    value: { required: true }
  },
  data() {
    return {
      adapterSpec: fullSpec,
      selectedIds: [],

      deleteIsValid: false,
      deleteComments: null,
      isSet
    }
  },
  mounted() {
    this.reload()
  },
  computed: {
    // reportSpec é computed porque o filtro de OccurConfig
    // precisa do orgId, então se a org muda a spec tb precisa mudar.
    reportSpec() {
      return {
        title: 'Ocorrências',
        filters: [
          {
            type: 'DateTime',
            prefix: 'createdFromDate',
            noSuffix: true,
            showInMenu: true,
            label: 'Criados a partir de'
          },
          {
            type: 'DateTime',
            prefix: 'createdUntilDate',
            noSuffix: true,
            isEnd: true,
            showInMenu: true,
            label: 'Criados até'
          },
          {
            type: 'DateTime',
            prefix: 'fromDate',
            noSuffix: true,
            showInMenu: true,
            label: 'Ocorrido a partir de'
          },
          {
            type: 'DateTime',
            prefix: 'untilDate',
            defVal: utils.sod(null, 1),
            noSuffix: true,
            isEnd: true,
            showInMenu: true,
            label: 'Ocorrido até'
          },
          {
            type: 'OccurConfig',
            prefix: 'config',
            showInMenu: true,
            orgId: this.value.id,
            label: 'Tipo da ocorrência'
          },
          {
            type: 'VehicleTag',
            prefix: 'vehicle',
            showInMenu: true,
            orgId: this.value.id,
            label: 'Tag de veículo'
          }
        ],
        orderByOptions: [
          { text: 'Criados mais recentes no topo', value: 'id desc' },
          { text: 'Relógio mais recente no topo', value: 'startTimestamp desc' }
        ]
      }
    },

    menuOpts() {
      return [
        {
          text: 'Remover...',
          icon: 'mdi-delete',
          disabled: this.selectedIds.length < 1,
          onClick: () => this.confirmDelete()
        }
      ]
    }
  },
  watch: {
    value() {
      this.reload()
    }
  },
  methods: {
    reload() {
      this.$refs.report.reload()
    },

    async fetchData(ps) {
      let fetcher = new OrgApi(this.value.id)
      let data = await fetcher.get('occurrences', ps)
      return data
    },

    async showRowDetails({ row }) {
      let ps = {}
      await this.$rootLoading(async () => {
        let occur = await new OrgApi(this.value.id).get('occurrences/' + row.id)
        ps.tripId = occur.startTripId
        ps.orgId = this.value.id
      })

      await this.$vis(ps)
    },

    confirmDelete() {
      this.deleteComments = null
      this.deleteIsValid = true
      this.$refs.deleteDialog.open()
      if (this.$refs.deleteForm) this.$refs.deleteForm.resetValidation()
    },

    async doDelete() {
      this.$refs.deleteForm.validate()
      if (this.deleteIsValid) {
        this.$refs.deleteDialog.dismiss()
        this.$rootLoading(async () => {
          let body = {
            occurIds: this.selectedIds,
            comments: this.deleteComments,
            login: TheUser.user.login
          }
          let fetcher = new OrgApi(this.value.id)

          await fetcher.post('occurrences/clean', body)

          this.selectedIds = []
          this.deleteComments = null
          this.deleteIsValid = true

          this.$snack('Registros removidos com sucesso')
          this.reload()
        })
      }
    }
  }
}
</script>

<style></style>
